export const LOAD_LOGS_ATTEMPT = 'admin/monitoring/LOAD_LOGS_ATTEMPT'
export const LOAD_LOGS_SUCCESS = 'admin/monitoring/LOAD_LOGS_SUCCESS'
export const LOAD_LOGS_FAILURE = 'admin/monitoring/LOAD_LOGS_FAILURE'

export const SET_PARAMS = 'admin/monitoring/SET_PARAMS'

export const RESET_MONITORING = 'admin/monitoring/RESET_MONITORING'
